import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

function addPreview (preview) {
  const database = firebase.firestore()
  return new Promise(resolve => {
    resolve(database.collection('previews').add({preview}))
  })
    .then(res => {
      return res.id
    })
    .catch(err => console.log(err))
}

function getPreviewById (id) {
  const database = firebase.firestore()
  return new Promise(resolve => {
    resolve(database.collection("previews").doc(id).get())
  })
    .then(res => {
      return res.data()
    })
}

export default {
  addPreview,
  getPreviewById
}
